@if (inActiveShare) {
  <div layout layout-vertical>
    <div layout layout-vertical gap-small-x>
      @for (container of containers(); track trackById($index, container)) {
        <rt-box variant="padding-small">
          <div layout layout-vertical layout-full-width>
            <rt-heading>
              {{
                container.name
                  ? '"' + container.name + '"'
                  : ('app.candidate.share_dialog.anyone.container_without_name' | translate)
              }}
            </rt-heading>
            <div layout layout-horizontal-wrap>
              {{
                'app.candidate.share_dialog.anyone.link_created_on'
                  | translate: { date: container.createdAt | date: 'd MMM' }
              }}
              <rt-divider variant="dot" />
              {{
                'app.candidate.share_dialog.anyone.x_candidates_shared'
                  | translate: { count: container.candidatesCount }
              }}
            </div>
            <rt-group variant="stacked" layout margin-top-medium gap-small-x>
              <rt-form-field layout-flex-1-1>
                <rt-input
                  variant="rounded"
                  [value]="container.shareUrl!"
                  [readOnly]="true"
                  (click)="copy(containerUrl)"
                  #containerUrl
                >
                  <rt-icon-button
                    suffix
                    variant="plain"
                    iconName="open-in-new"
                    size="small"
                    (click)="handleShareUrlIconClick(container)"
                  />
                </rt-input>
              </rt-form-field>
              <rt-button variant="tertiary" (click)="copy(containerUrl)">
                <rt-icon name="content-copy" />
                <span>{{ 'app.common.copy_to_clipboard' | translate }}</span>
              </rt-button>
              <rt-icon-button
                variant="outline"
                iconName="more-horiz"
                (click)="editContainerClick.emit(container)"
              />
            </rt-group>
          </div>
        </rt-box>
      }
    </div>
    <div (click)="toggleShareAgain()" class="toggler">
      <rt-heading variant="subheading" margin-right-small-xx>
        {{ 'app.candidate.share_dialog.anyone.share_again' | translate }}
      </rt-heading>
      <rt-icon [name]="shareAgainExpanded ? 'keyboard-arrow-up' : 'keyboard-arrow-down'" />
    </div>
    @if (shareAgainExpanded) {
      <div margin-top>
        <ng-container *ngTemplateOutlet="sharingButtons" />
      </div>
    }
  </div>
}
@if (!inActiveShare) {
  <div layout layout-vertical>
    <rt-heading variant="subheading">
      {{ 'app.candidate.share_dialog.anyone.empty_state.heading' | translate }}
    </rt-heading>
    <p>
      {{
        'app.candidate.share_dialog.anyone.empty_state.subheading'
          | translate: { companyName: currentCompany().name | truncate: 30 }
      }}
    </p>
    <div margin-top margin-bottom>
      <ng-container *ngTemplateOutlet="sharingButtons" />
    </div>
  </div>
}

<ng-template #sharingButtons>
  <div layout layout-vertical gap-medium>
    <rt-new-item-button
      icon="link"
      [heading]="'app.candidate.share_dialog.anyone.buttons.new_link.heading' | translate"
      [subheading]="'app.candidate.share_dialog.anyone.buttons.new_link.subheading' | translate"
      (click)="newLinkClick.emit()"
    />
    <rt-new-item-button
      icon="link-add-to-existing"
      [heading]="'app.candidate.share_dialog.anyone.buttons.add_to_existing.heading' | translate"
      [subheading]="
        'app.candidate.share_dialog.anyone.buttons.add_to_existing.subheading' | translate
      "
      (click)="addToExisting.emit()"
    />
  </div>
</ng-template>
